import Layout from '@/layout'

const route = {
  path: '/ommerce',
  component: Layout,
  redirect: '/ommerce/index',
  alwaysShow: true, // will always show the root menu
  name: 'ommerce',
  meta: {
    title: '跨境电商',
    icon: 'kjds',
    roles: [
      'cross_border_ecommerce'
    ]
  },
  children: [
    // 图表分析
    {
      path: '/ommerce/cardnumber/index',
      component: () => import('@/views/ommerce/cardnumber/index.vue'),
      name: 'linkconfig',
      meta: {
        title: '卡号管理',
        // icon: 'component',
        roles: [
          'payoneer_card'
        ]
      }
    },
    {
      path: '/tiktok/adSetting/index',
      component: () => import('@/views/tiktokLink/adSetting/index.vue'),
      name: 'tiktokAdSetting',
      meta: {
        title: '广告设置',
        roles: [
          'tiktok.ad_element'
        ]
      }
    }
  ]
}

export default route
